import React from "react";
import ReactDOM from "react-dom/client";

import {
  HelmetProvider,
} from "react-helmet-async";

import App from "./App";
import { savePublicCache } from "./utils/publicDataCache";

import "./styles/design-system.css";
import "./index.css";

/*
 * cPanel PHP renderers embed the exact public dataset used for crawlable HTML.
 * Seed ResultWale's existing cache before React mounts so the first render does
 * not immediately depend on a cross-origin backend request.
 */
const bootstrap = window.__RESULTWALE_BOOTSTRAP__;

if (
  bootstrap &&
  typeof bootstrap === "object" &&
  typeof bootstrap.cacheKey === "string" &&
  bootstrap.cacheKey.trim() &&
  Object.prototype.hasOwnProperty.call(bootstrap, "data")
) {
  savePublicCache(bootstrap.cacheKey, bootstrap.data);
}

try {
  delete window.__RESULTWALE_BOOTSTRAP__;
} catch {
  window.__RESULTWALE_BOOTSTRAP__ = undefined;
}

const rootElement =
  document.getElementById("root");

if (!rootElement) {
  throw new Error(
    'Root element with id "root" was not found.',
  );
}

const root =
  ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);